<template>
  <div>
    <menu-drop-down ref="menu" :disabled="disabled" :menu="menu" />

    <input
      type="file"
      id="file"
      title=""
      style="display: none"
      ref="file"
      @change="handleFileUpload"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import MenuDropDown from '../Menu';

export default {
  components: {
    MenuDropDown,
  },
  data: () => ({
    file: '',
  }),
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ...mapActions('application', ['setLoading']),
    openFileInput() {
      const input = document.getElementById('file');
      input.value = null;
      input.click();
      this.$refs.menu.close();
    },
    openManifestedXmlsModal() {
      this.$refs.menu.close();
      this.$emit('manifest');
    },
    async handleFileUpload() {
      const file = this.$refs.file.files[0];
      if (!file) return;
      this.$emit('file', file);
    },
  },
  computed: {
    menu() {
      return {
        name: 'Importar XML',
        children: [
          {
            id: 'manifest',
            name: 'Manifestos',
            onClick: this.openManifestedXmlsModal,
          },
          {
            id: 'choose-file',
            name: 'Escolher Arquivo',
            onClick: this.openFileInput,
          },
        ],
      };
    },
  },
};
</script>

<style>
input[type='file'] {
  width: 91px;
  color: transparent;
}
</style>
